import React from 'react';
import { NavigationProps } from '../types/navigation';
import { Button } from '../components/ui/Button';
import { Share2, Copy, Users } from 'lucide-react';
import { useStore } from '../lib/store';
export function FriendsPage({
  onNavigate
}: NavigationProps) {
  const {
    user
  } = useStore();
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-476">
      <div className="bg-gradient-to-b from-[#67E8F9] to-[#E0F2FE] pt-12 pb-12 px-6 text-center rounded-b-[3rem]" data-id="element-477">
        <div className="w-20 h-20 bg-white/30 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-sm" data-id="element-478">
          <Users className="w-10 h-10 text-blue-900" data-id="element-479" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-480">
          Catch with Friends
        </h1>
        <p className="text-gray-700 max-w-xs mx-auto" data-id="element-481">
          Invite friends to join the crew. You get{' '}
          <span className="font-bold" data-id="element-482">+40 points</span> when they redeem their
          first catch!
        </p>
      </div>

      <div className="px-6 -mt-8" data-id="element-483">
        <div className="bg-white rounded-2xl p-6 shadow-lg space-y-6" data-id="element-484">
          <div className="text-center" data-id="element-485">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-486">
              Your Invite Link
            </p>
            <div className="bg-gray-100 p-3 rounded-xl flex items-center justify-between" data-id="element-487">
              <code className="text-blue-600 font-mono text-sm" data-id="element-488">
                gofish.app/join/{user?.name?.toLowerCase() || 'fisher'}
              </code>
              <button className="p-2 hover:bg-white rounded-lg transition-colors" data-id="element-489">
                <Copy className="w-4 h-4 text-gray-500" data-id="element-490" />
              </button>
            </div>
          </div>

          <Button className="w-full" data-id="element-491">
            <Share2 className="w-4 h-4 mr-2" data-id="element-492" />
            Share Link
          </Button>
        </div>

        <div className="mt-8" data-id="element-493">
          <h3 className="font-bold text-gray-900 mb-4" data-id="element-494">Your Crew</h3>
          <div className="bg-white rounded-xl p-6 text-center text-gray-500 border border-gray-100 border-dashed" data-id="element-495">
            <p data-id="element-496">No friends yet.</p>
            <p className="text-sm mt-1" data-id="element-497">Start sharing to earn badges!</p>
          </div>
        </div>
      </div>
    </div>;
}